import React from "react";
import PropTypes from "prop-types";
import { getLabel } from "../../lib/utils";

function Text({
  label,
  field,
  value,
  handleChange,
  placeholder,
  minLength,
  maxLength,
  required,
  disabled,
  type,
}) {
  return (
    <div>
      <label className="uk-form-label">{getLabel(label, required)}</label>
      <div className="uk-form-controls">
        <input
          className="uk-input"
          type={type || "text"}
          value={value}
          onChange={(e) => handleChange(field, e.target.value)}
          placeholder={placeholder}
          minLength={minLength}
          maxLength={maxLength}
          disabled={disabled}
        />
        <div className="uk-text-meta">
          {minLength}-{maxLength} characters
        </div>
      </div>
    </div>
  );
}

Text.propTypes = {
  label: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  value: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  minLength: PropTypes.number.isRequired,
  maxLength: PropTypes.number.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  type: PropTypes.string,
};

export default Text;
